/*
    * Backbone View: DeviceHistory
    * ----------------------
    * Shows history of actions against a given device.
    *
*/
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import $ from 'jquery';
import CollectionTable from '@/views/collection_table';
import template from '@/../templates/standard-list-layout.hbs';
import history_item_template from '@/../templates/device-history-item.hbs'; 

var HistoryItemView = Marionette.View.extend({
    template: Handlebars.compile(history_item_template),
    tagName: 'li',
    className: 'list-group-item history-item',
    ui: {
        actor_name: '.actor-name',
        devicegroup_name: '.devicegroup-name'
    },
    onRender: function(){
        var apiCh = Radio.channel('api');
        var devicegroups = apiCh.request('development_devicegroup');
        var accounts = apiCh.request('account');

        var self = this;
        if (self.model.get('devicegroup_id')) {
            devicegroups.async_lookup(self.model.get('devicegroup_id')).then(function (devicegroup) {
                $(self.ui.devicegroup_name).text(devicegroup.get('name'));
            });
        } else {
            $(self.ui.devicegroup_name).text('');
        }
        if (self.model.get('actor_id')) {
            accounts.async_lookup(self.model.get('actor_id')).then(function(account){
                $(self.ui.actor_name).text(account.get('username'));
            });
        } else {
            $(self.ui.actor_name).text('[Deleted Account]');
        }
    },
    templateContext: function(){
        let event = this.model.get('event');
        typeof event !== 'string' ? event = '' : event; 
        var release = this.model.get('release') || '[release version n/a]';
        var from_or_to;
        switch (event) {
            case 'deleted':
                from_or_to = '';
                break;
            case 'unassigned':
                from_or_to = 'from';
                break;
            case 'enroled':
                from_or_to = this.model.get('devicegroup_id') ? 'to' : '';
                break;
            case 'assigned':
                from_or_to = 'to';
                break;
            case 'blessed':
                from_or_to = 'to';
                break;
            case 'improm_upgrading':
                from_or_to = 'to ' + release + ' ';
                break;
            default:
                from_or_to = '';
                break;
        }
        return {
            from_or_to: from_or_to,
            event: event.replace('_', ' '),
        };
    },
});

var HistoryView = Marionette.View.extend({
    className: 'device-history',
    template: Handlebars.compile(template),
    regions: {
        list: '.content-region',
    },
    ui: {
        section: 'section',
        header: '.header',
    },
    onRender: function (options) {
        this.ui.header.hide();

        var history = this.getOption('device').history;

        var list_view = CollectionTable.extend({
            initialize: function(options){
                options.columns = [
                    // {
                    //     // name: 'History',
                    //     // class_name: 'history',
                    // }
                ];
                options.secondary_sort = 'history';
                options.default_sort_desc = true;
                options.default_sort_column = 1;
                CollectionTable.prototype.initialize.call(this, options);
            },
            childView: HistoryItemView,
            class_name: 'products-list list-group history-list'
        });
        history.fetch({
            data: {
                'page[size]': 100
            }
        })
        .then(function(resp){
            this.showChildView('list', new list_view({collection: history}));
        }.bind(this));
    }
});

export default HistoryView;

